import * as React from 'react';
import './field-alert.scss';

interface IFieldAlert {
  children: React.ReactNode;
  error?: string;
  className?: string;
}

export default function FieldAlert(props: IFieldAlert) {
  const { className = '', error = '', children } = props;
  return (
    <div className={`field-alert ${className}`}>
      <span className="field-alert__field-container">{children}</span>
      {error && (
        <div className="field-alert__alert" role="alert">
          {error}
        </div>
      )}
    </div>
  );
}
